const featureBlock = (block) => {

	const icons = block.querySelectorAll('.pp-block-feature__icon');
	const descriptions = block.querySelectorAll('.pp-block-feature__description' );
	const overlays = block.querySelectorAll('.pp-block-feature__overlay');
  const leftArrows = block.querySelectorAll('.pp-block-feature__arrow-left');
  const rightArrows = block.querySelectorAll('.pp-block-feature__arrow-right');

  const setDefaults = () => {

    if (icons.length > 0) {
      icons[0].classList.add('active');
    }

    if (descriptions.length > 0) {
      descriptions[0].classList.add('active');
    }

    if (overlays.length > 0) {
      overlays[0].classList.add('active');
    }
  };

  const findCurrentIndex = () => {

    let activeIndex = null;

    if (overlays.length > 0) {

      overlays.forEach((overlay, index) => {
        if (overlay.classList.contains('active')) {
          activeIndex = index;
        }
      });
    }

    return activeIndex;
  }

	const updateActiveElements = (slug, icon) => {

    if (descriptions.length > 0) {

      descriptions.forEach((description, index) => {

        description.classList.remove('active');

        if (description.dataset.slug === slug) {
          description.classList.add('active');
        }
      });
    }

    if (overlays.length > 0) {

      overlays.forEach((overlay) => {

        overlay.classList.remove('active');

        if (overlay.dataset.slug === slug) {
          overlay.classList.add('active');
        }
      });
    }

    if (icons.length > 0) {

      icons.forEach((icon) => {
        icon.classList.remove('active');

        if (icon.dataset.slug === slug) {
          icon.classList.add('active');
        }
      });
    }


	};

  const updateIndex = (arrow) => {

    const index = findCurrentIndex();

    descriptions[index].classList.remove('active');
    overlays[index].classList.remove('active');
    icons[index].classList.remove('active');

    if (arrow.classList.contains('pp-block-feature__arrow-right')) {

      if (index === overlays.length - 1) {

        overlays[0].classList.add('active');
        descriptions[0].classList.add('active');
        icons[0].classList.add('active');
      } else {
        overlays[index + 1].classList.add('active');
        descriptions[index + 1].classList.add('active');
        icons[index + 1].classList.add('active');
      }
    }

    if (arrow.classList.contains('pp-block-feature__arrow-left')) {

      if (index === 0) {

        overlays[overlays.length - 1].classList.add('active');
        descriptions[overlays.length - 1].classList.add('active');
        icons[overlays.length - 1].classList.add('active');

      } else {

        overlays[index +- 1].classList.add('active');
        descriptions[index +- 1].classList.add('active');
        icons[index +- 1].classList.add('active');
      }
    }
  }

  if (rightArrows) {

    rightArrows.forEach((arrow) => {

      arrow.addEventListener('click', (e) => {

        updateIndex(e.target);
      })
    })
  }

  if (leftArrows) {

    leftArrows.forEach((arrow) => {

      arrow.addEventListener('click', (e) => {

        updateIndex(e.target);
      })
    })
  }

  if (icons) {

    icons.forEach((icon) => {
      const { slug } = icon.dataset;

      icon.addEventListener('click', () => {
        if (document.documentElement.clientWidth ||
            document.body.clientWidth ||
            window.innerWidth >= 1024) {
          updateActiveElements(slug, icon);
        }
      });
    });
  }

  setDefaults();
};

document.addEventListener('DOMContentLoaded', () => {
	const featuresBlocks = document.querySelectorAll('.pp-block-features');

	featuresBlocks.forEach((block) => {
		featureBlock(block);
	});
});

